function positionClosingQuote() {
  const quoteText = document.querySelector('.founder-quote__text p span');
  if (!quoteText) return;

  const parent = quoteText.parentElement;
  const text = quoteText.textContent.trim();
  
  const range = document.createRange();
  const textNode = quoteText.firstChild;
  
  if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return;
  
  const styles = window.getComputedStyle(quoteText);
  const lineHeight = parseFloat(styles.lineHeight) || parseFloat(styles.fontSize) * 1.2;
  
  let lines = [];
  let currentLineStart = 0;
  let previousTop = null;
  
  for (let i = 0; i < text.length; i++) {
    range.setStart(textNode, i);
    range.setEnd(textNode, i + 1);
    const rect = range.getBoundingClientRect();
    
    if (previousTop === null) {
      previousTop = rect.top;
    } else if (Math.abs(rect.top - previousTop) > lineHeight / 2) {
      lines.push({ start: currentLineStart, end: i - 1 });
      currentLineStart = i;
      previousTop = rect.top;
    }
  }
  
  lines.push({ start: currentLineStart, end: text.length - 1 });
  
  if (lines.length === 0) {
    range.detach();
    return;
  }
  
  const lastLine = lines[lines.length - 1];
  range.setStart(textNode, lastLine.start);
  range.setEnd(textNode, lastLine.end + 1);
  const lastLineRect = range.getBoundingClientRect();
  const lastLineWidth = lastLineRect.width;
  
  parent.style.setProperty('--last-line-width', `${lastLineWidth - 8}px`);
  parent.style.setProperty('--total-lines', lines.length);
  
  range.detach();
}

function initFounderQuote() {
  setTimeout(positionClosingQuote, 50);
  
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(positionClosingQuote, 100);
  });
  
  const observer = new MutationObserver(function() {
    positionClosingQuote();
  });
  
  const quoteText = document.querySelector('.founder-quote__text p span');
  if (quoteText) {
    observer.observe(quoteText, { childList: true, characterData: true, subtree: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFounderQuote);
} else {
  initFounderQuote();
}
